import React from 'react';
import { Row, Col, Input, Form, Select } from 'antd';

interface propsTypes {
  dataList: void | any
}
const FormItem = Form.Item
const Option = Select.Option
const GeneralEdit = (props: propsTypes) => {
  return (
    <>
      <Row gutter={24} style={{ paddingLeft: 2 }}>
        <Col span={6}>
          <FormItem name="efficientappliances" label="Efficient Appliances">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="efficientlighting" label="Efficient Lighting">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="heatpowercombined" label="Heat/Power Combined">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={5}></Col>
        <Col span={6}>
          <FormItem name="heatpump" label="Heat Pump">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="powersavingpolicy" label="Power Saving Policy">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="solar" label="Solar">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={5}></Col>
        <Col span={6}>
          <FormItem name="tempcontrols" label="Temperature Controls">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="windturbine" label="Wind Turbine">
            <Select allowClear showSearch>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="energygeneratedamount" label="Energy Generated Amount" rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}>
            <Input />
          </FormItem>
        </Col>
        <Col span={5}></Col>
        <Col span={6}>
          <FormItem name="energystarrating" label="Energy Star Rating" rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}>
            <Input />
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="energyintensityamount" label="Energy Intensity Amount" rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}>
            <Input />
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="energyintensityuom" label="Energy Intensity Unit Of Measure">
            <Select allowClear showSearch>
              <Option value="BTU/SqF">BTU/SqF</Option>
              <Option value="MJ/SqM">MJ/SqM</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span={5}></Col>
        <Col span={6}>
          <FormItem
            name="energyintensitytimeperiod"
            label="Energy Intensity Time Period"
            rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}
            extra={<span className="blue-font">In Months</span>}
          >
            <Input />
          </FormItem>
        </Col>
      </Row>
    </>
  )
}


export default GeneralEdit;
